import React, { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import styles from './styles.module.scss';

import Hero from '../../components/Category/Hero';
import List from '../../components/Category/List';
import Catalog from '../../components/Category/Catalog';
import { getCart } from '../../redux/actions/cartActions';

import ApiCatalogCMS from '../../api/Catalog/CategoryCMS';
import ApiProductCMS from '../../api/Product/index';
import ApiCatalog from '../../api/Catalog/Category';
import ApiSearch from '../../api/Search/Search';
import ApiCart from '../../api/Cart/CartApiFL';

import Config, { spanish } from '../../config/config';

const CategoryPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [hero, setHero] = useState(null);
  const [productsByCatId, setProductsByCatId] = useState([]);
  const [productsByCatIdAPI, setProductsByCatIdAPI] = useState([]);
  const [hasSearchResults, setHasSearchResults] = useState(true);
  const [isLoadingSearch, setIsLoadingSearch] = useState(true);
  const [stateCategoryId, setStateCategoryId] = useState(
    history.location.state?.categoryId
  );
  const rawStateCategoryId = history.location.state?.categoryId;
  const [isSearch, setIsSearch] = useState(false);
  const searchTerm = history.location.state?.searchTerm;
  const cartId = useSelector((globalState) => globalState.cartInfo.IdCarrito);
  const estadoId = useSelector(
    (globalState) => globalState.estadoSelection.selectedEstadoId
  );
  const currentCart = useSelector(
    (globalState) => globalState.cartInfo.InfoCarrito
  );
  const estadoIdInteger = parseInt(estadoId, 10);
  const slug = history.location.pathname.replace(/\/.*\//, '');
  const categoryID =
    rawStateCategoryId !== undefined ? rawStateCategoryId : slug;

  useEffect(async () => {
    const localCMSCategories = JSON.parse(
      sessionStorage.getItem('cmsCategories')
    );
    const categories = !localCMSCategories
      ? await ApiCatalogCMS.getCategories()
      : localCMSCategories;
    sessionStorage.setItem('cmsCategories', JSON.stringify(categories));
    const current = categories?.find((item) => item?.categoryID === categoryID);
    setStateCategoryId(current?.categoryID);
    setHero(current);
  }, [categoryID]);

  const getProductsByCategoryId = useCallback(
    async (categoryId, estadoIdParam) => {
      setIsLoadingSearch(true);
      let apiProducts = JSON.parse(sessionStorage.getItem('apiProducts'));
      const payload = {
        Cliente: Config.api_services.client,
        Pais: 'MEX',
        Ambiente: Config.api_services.environment,
        idCategoria: 0,
        IdEstado: estadoIdParam,
      };

      const params = `?categoryID=${categoryId}`;
      try {
        const resp = await ApiCatalogCMS.getCategories(params);
        if (!apiProducts) {
          apiProducts = await ApiCatalog.getProductsByCategoryId(payload);
        }
        if (resp && resp[0] && apiProducts) {
          setIsLoadingSearch(false);
          const productListCMS = resp[0].products;
          const productListAPI = apiProducts.length
            ? apiProducts
            : apiProducts.ListaProductos;
          sessionStorage.setItem('apiProducts', JSON.stringify(productListAPI));

          const finalProductListCMS = () => {
            let filteredProductListCMS = [];
            filteredProductListCMS = productListCMS?.filter((productCMS) =>
              productListAPI?.find(
                (productAPI) =>
                  productAPI?.cve_prod.toString() === productCMS?.SKU
              )
            );
            filteredProductListCMS = filteredProductListCMS.filter(
              (el) => el.SKU !== '801' && el.SKU !== '902' && el.SKU !== '6954'
            );
            return filteredProductListCMS;
          };

          const finalProductListAPI = () => {
            let filteredProductListAPI = [];
            filteredProductListAPI = productListAPI?.filter((productApi) =>
              productListCMS?.find(
                (productCMS) =>
                  productCMS?.SKU === productApi?.cve_prod.toString()
              )
            );
            return filteredProductListAPI;
          };

          setProductsByCatId(finalProductListCMS());
          setProductsByCatIdAPI(finalProductListAPI());
        }
      } catch (error) {
        console.log(error);
      }
    },
    [rawStateCategoryId, stateCategoryId]
  );

  const getProductsBySearchTerm = useCallback(async (term) => {
    setIsLoadingSearch(true);
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      Termino: term,
      IdEstado: estadoIdInteger,
    };

    try {
      const resp = await ApiSearch.getSearchByTerm(payload);

      if (resp && resp.ListaProductos.length) {
        const cmsProducts = JSON.parse(sessionStorage.getItem('cmsProducts'));
        const respCMS =
          cmsProducts !== null
            ? cmsProducts
            : await ApiProductCMS.getAllProducts();
        sessionStorage.setItem('cmsProducts', JSON.stringify(respCMS));
        if (respCMS.length) {
          setHasSearchResults(true);

          const cmsFilter = respCMS.filter((productCMS) =>
            resp.ListaProductos.find(
              (productsApi) =>
                productsApi.cve_prod.toString() === productCMS.SKU &&
                productCMS.SKU !== '801' &&
                productCMS.SKU !== '6954' &&
                productCMS.SKU !== '902'
            )
          );

          const apiFilter = resp.ListaProductos.filter((productApi) =>
            respCMS.find(
              (productCMS) =>
                productCMS.SKU === productApi.cve_prod.toString() &&
                productApi.cve_prod !== 801 &&
                productApi.cve_prod !== 6954
            )
          );

          setProductsByCatId(cmsFilter);
          setProductsByCatIdAPI(apiFilter);
          setIsLoadingSearch(false);
        }
      }

      if (resp && resp.ListaProductos.length === 0) {
        setIsLoadingSearch(false);
        setHasSearchResults(false);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const addToCart = async (productId) => {
    dispatch(getCart(cartId));
    const currentCartDetail = currentCart[0]?.DetalleCarrito;
    const cartProd = currentCartDetail?.filter(
      (el) => el.idProducto === productId
    );
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      AgregarCarrito: {
        IdCarrito: cartId,
        IdEstado: estadoId,
        TipoVenta: 1,
        FormaVenta: 3,
        IdFbo: 0,
        Productos: [
          {
            Cve_Prod: productId,
            Cantidad: cartProd?.length > 0 ? cartProd[0].Cantidad + 1 : 1,
            TipoUnidad: 'PI',
          },
        ],
      },
    };
    const resp =
      cartProd?.length > 0
        ? await ApiCart.updateCart(payload)
        : await ApiCart.addToCart(payload);
    if (resp.Codigo === 200) {
      dispatch(getCart(resp.IdCarrito));
    }
  };

  useEffect(() => {
    if (categoryID) {
      setIsSearch(false);
      getProductsByCategoryId(categoryID, estadoIdInteger);
    }

    if (searchTerm) {
      setIsSearch(true);
      getProductsBySearchTerm(searchTerm);
    }
  }, [categoryID, searchTerm, estadoId]);

  const isSearchPage = window.location.pathname.includes('search');

  return (
    <div className={styles.container}>
      <Helmet
        title={spanish ? hero?.NameSpanish : hero?.NameEnglish}
        meta={[
          {
            name: 'description',
            content: spanish
              ? hero?.DescriptionSpanish
              : hero?.DescriptionEnglish,
          },
        ]}
      />
      {isSearchPage ? (
        ''
      ) : (
        <Hero hero={hero} isLoadingSearch={isLoadingSearch} />
      )}
      <div className={styles.content}>
        <List spanish={spanish} />
        <Catalog
          products={productsByCatId}
          productsAPI={productsByCatIdAPI}
          isSearch={isSearch}
          searchTerm={searchTerm}
          hasSearchResults={hasSearchResults}
          isLoadingSearch={isLoadingSearch}
          spanish={spanish}
          addToCart={addToCart}
        />
      </div>
    </div>
  );
};

export default CategoryPage;
